@let fundingViewModel = fundingViewModel$ | async;
<div class="funding-container">
  @if (featureSettingsService.financementEnabled) {
  <div class="body-header">
    <div id="title-slider">
      <span class="casto-title" [innerHTML]="'funding.title' | translate"></span>
      <div class="slider-input-container">
        <span [innerHTML]="'funding.down-amount' | translate"></span>
        <div class="slider-container">
          <div class="slider">
            <p-slider
              [(ngModel)]="downPaymentValue"
              [min]="0"
              [max]="fundingViewModel.currentPricing?.totalWithoutFunding.actualAmount"
              [step]="0.01"
              (onSlideEnd)="updateFunding()"
              [disabled]="loading || fundingViewModel.pricingLoading" />
            <div class="min-max">
              <span [innerHTML]="0 | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'"></span>
              @if (fundingViewModel.pricingLoading) {
                <p-skeleton width="4rem" height="1rem"></p-skeleton>
              } @else {
                <span
                  [innerHTML]="
                  fundingViewModel.currentPricing?.totalWithoutFunding.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                "></span>
              }
            </div>
          </div>
          <p-inputNumber
            #pInput
            [(ngModel)]="downPaymentValue"
            mode="currency"
            inputId="currency-france"
            currency="EUR"
            locale="fr-FR"
            styleClass="down-payment-input"
            (keydown.enter)="updateFunding()"
            [disabled]="loading || fundingViewModel.pricingLoading" />


        </div>
      </div>
    </div>
    <div id="amounts">

      <div class="amount">

        <span class="casto-title" [innerHTML]="'funding.total-amount' | translate"></span>
        @if (fundingViewModel.pricingLoading || loading) {
          <p-skeleton width="6rem" height="1rem"></p-skeleton>
        } @else {
          <div class="amount-values">
            @if (fundingViewModel.displayDiscount) {
              <span
                class="casto-discount"
                [innerHTML]="
                            fundingViewModel.currentPricing.totalWithoutFunding.baseAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                          "></span>
            }
            <span
              class="blue"
              [innerHTML]="
            fundingViewModel.currentPricing?.totalWithoutFunding.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
          "></span>
          </div>
        }
      </div>
      <div class="amount">
        <span class="casto-title" [innerHTML]="'funding.funding-amount' | translate"></span>
        @if (fundingViewModel.pricingLoading || loading) {
          <p-skeleton width="6rem" height="1.25rem"></p-skeleton>
        } @else {
          <span class="casto-tag"
                [innerHTML]="fundingViewModel.fundingAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'"></span>
        }
      </div>
    </div>
  </div>

  <div class="panel">
    <div class="panel-content">
      <div class="casto-card">
        <div class="content">
          <!--          Si pas d'offres-->
          @if (fundingViewModel.isNoOffer) {
            <!--            Si ça charge, alors on affiche un tableau avec que des skeleton (pour la cohérence)-->
            @if (loading || fundingViewModel.pricingLoading) {
              <p-table styleClass="casto-table" [value]="[]"
                       [loading]="loading || fundingViewModel.pricingLoading">
                <ng-template pTemplate="header">
                  <tr>
                    @for (col of offersColumns; track col) {
                      <th>
                        {{ col.header }}
                      </th>
                    }
                  </tr>
                </ng-template>
                <ng-template pTemplate="loadingbody">
                  @for (row of createSkeletonRow(); track row) {
                    <tr>
                      @for (col of offersColumns; track col) {
                        <td>
                          <p-skeleton styleClass="offer-table-skeleton" />

                        </td>
                      }
                    </tr>
                  }
                </ng-template>
              </p-table>
            } @else {
              <span class="no-offer" [innerHTML]="'funding.no-offers'|translate"></span>
            }
          } @else {
            <p-table styleClass="casto-table" [value]="fundingViewModel.offersWithFooter"
                     [scrollable]="true"
                     scrollHeight="100%"
                     [loading]="loading || fundingViewModel.pricingLoading">
              <ng-template pTemplate="header">
                <tr>
                  @for (col of offersColumns; track col) {
                    <th>
                      {{ col.header }}
                    </th>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-offer>
                @if (!(loading || fundingViewModel.pricingLoading)) {
                  @if (offer.isTextContainer) {
                    <!-- Ligne spéciale pour le texte de financement -->
                    <tr class="funding-row">
                      <td [attr.colspan]="offersColumns.length" class="funding-cell">
                        <div class="funding-text-container">
                          <span [innerHTML]="fundingViewModel.funding?.txtAssurance"></span>
                          <span [innerHTML]="fundingViewModel.funding?.vac"></span>
                        </div>
                      </td>
                    </tr>
                  } @else {
                    <!-- Lignes normales du tableau -->
                    <tr
                      [ngClass]="{
                highlighted: isOfferSelected(offer, fundingViewModel.funding),
              }"
                      (click)="selectOffer(offer)">
                      <td>{{ offer.code }}</td>
                      <td>{{ offer.offer }}</td>
                      <td>
                <span
                  class="blue"
                  [innerHTML]="offer.mensuality | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'"></span>
                      </td>
                      <td>{{ offer.duration }}</td>
                      <td [innerHTML]="offer.interest | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'"></td>
                      <td [innerHTML]="offer.total | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'"></td>
                      <td>
                        <span class="casto-tag">{{ offer.taeg }}%</span>
                      </td>
                    </tr>
                  }
                }
              </ng-template>
              <ng-template pTemplate="loadingbody">
                @for (row of createSkeletonRow(); track row) {
                  <tr>
                    @for (col of offersColumns; track col) {
                      <td>
                        <p-skeleton styleClass="offer-table-skeleton" />

                      </td>
                    }
                  </tr>
                }
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <div class="offer-error-container">
                  <span
                    class="no-offer" [innerHTML]="'funding.error'|translate"></span>
                  <ng-casto-button [label]="'Relancer la recherche'" (click)="updateFunding()"></ng-casto-button>
                </div>
              </ng-template>
            </p-table>
          }
        </div>
      </div>

    </div>
  </div>
  @if (!fundingViewModel.currentWithInstallation) {
    <div class="panel-content" (click)="setWithInstallation(true)" id="installation" [ngClass]="{
    disabled : loading || fundingViewModel.pricingLoading
    }">
      <div class="casto-card">
        <div class="header">
          <span class="casto-title" [innerHTML]="'installation.kitchen.with-installation.title'|translate : {
          amount: fundingViewModel.currentPricing?.delta.actualAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
          }"></span>
          <ng-casto-button class="primary" [label]="'generic.details'|translate"
                           (click)="setWithInstallation(true)"></ng-casto-button>
        </div>
      </div>
    </div>
  } @else {
    <div class="panel-content" (click)="setWithInstallation(false)" id="installation" [ngClass]="{
    disabled : loading || fundingViewModel.pricingLoading
    }">
      <div class="casto-card">
        <div class="header">
          <span class="casto-title" [innerHTML]="'installation.kitchen.without-installation.title'|translate : {
          amount: fundingViewModel.currentPricing?.delta.actualAmount| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
          }"></span>
          <ng-casto-button class="primary" [label]="'generic.details'|translate"
                           (click)="setWithInstallation(false)"></ng-casto-button>
        </div>
      </div>
    </div>
  }
  } @else {
    <div class="panel feature-disabled-panel">
      <div class="panel-content">
        <div class="alert alert-warning m-0 text-center" [innerHTML]="'feature-settings.warning.financement' | translate"></div>
      </div>
    </div>
  }
</div>
